import { ListGroupBy } from '@core/models/common/list-group-by';
import { ListSortBy } from '@core/models/common/list-sort-by';
import { ListSortDirection } from '@core/models/common/list-sort-direction';
import { PageMeta } from '@core/models/common/page-meta';
import { IListFilterState, initialListFilterState } from './list-filter-state';


export interface IListState {
    ids: string[];
    filteredIds: string[];
    relatedId: string;
    meta: PageMeta;
    filterBy: IListFilterState;
    groupBy: ListGroupBy;
    sortBy: ListSortBy;
    sortDisabled: boolean; // use this to disable local sorting through entity model files but can still specify sortBy/sortDirection for tracking
    sortDirection: ListSortDirection | ListSortDirection[];
    selectedIds: string[];
    selectedGroups: string[];
    highlightIds: string[];
    selectionMode: SelectionMode;
    isFetching: boolean;
    isFetchingMore: boolean;
    isBulkUpdating: boolean;
    selectedColumnIds: string[]
}

export const initialListState: IListState = {
    ids: [],
    filteredIds: [],
    relatedId: null,
    meta: null,
    filterBy: initialListFilterState(),
    groupBy: ListGroupBy.DATE,
    sortBy: ListSortBy.TIME,
    sortDirection: ListSortDirection.ASCENDING,
    sortDisabled: false,
    selectedIds: [],
    selectedGroups: [],
    highlightIds: [],
    selectionMode: null,
    isFetching: false,
    isFetchingMore: false,
    isBulkUpdating: false,
    selectedColumnIds: []
};
